import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

import { IBasePicker, IBasePickerSuggestionsProps, Label, mergeStyleSets, ValidationState, ITag, IBasePickerProps, TagPicker } from '@fluentui/react';

import { IField, ILookupField } from '../../../shared/interfaces';
import { Indici_FormMode, Search_QueryOperator } from '../../../shared/enums';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import axios from 'axios';
import { toastRef } from '../../Layout/Layout';
import fieldsService from '../../../services/fields.service';
import ArxeiaLabel from '../ArxeiaLabel';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    }
});



export interface AutocompleteHandle {
}

export interface AutocompleteProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
}


const Autocomplete: React.ForwardRefRenderFunction<AutocompleteHandle, AutocompleteProps> = (props, ref) => {

    const tagPickerRef = React.createRef<IBasePicker<ITag>>();

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    //const [mostRecentlyTagsUsed, setMostRecentlyTagsUsed] = useState<any[]>([]);


    let lookupField = props.field as ILookupField;
    let lookupFieldBasePickerProps = lookupField.basePickerProps ? lookupField.basePickerProps as IBasePickerProps<ITag> : undefined;

    let selectedTags: any[] = [];
    if (lookupField.internalValue)
        selectedTags = [...lookupField.internalValue];

    const basePickerSuggestionsProps: IBasePickerSuggestionsProps = lookupFieldBasePickerProps?.pickerSuggestionsProps ??
    {
        suggestionsHeaderText: 'Suggerimenti',
        //mostRecentlyUsedHeaderText: 'Risultati recenti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
        // con forceResolveText aggiungo un bottone per la ricerca custom e che chiama "createGenericItem", l'elemento
        // personalizzato da inserire oltre ai suggerimenti
        // controllo, inoltre, che il bottone ci sia solo nella form di Ricerca
        forceResolveText: "Cerca valore inserito",
        showForceResolve: props.formMode === Indici_FormMode.Search ? () => { return true } : () => { return false }
    };

    // utilizziamo l'item generic di createGenericTagPickerItem per permettere la ricerca di un elemento personalizzato
    // oltre ai suggerimenti: l'elemento custom viene passato ad una query che utilizza il metodo contains e restituisce
    // tutti i valori che contengono quell'elemento stesso, mentre i suggerimenti vengono passati ad una query che utilizza
    // il metodo equals e ritorna un valore identico al valore selezionato tra essi
    const createGenericItem = (input: string) => {
        let tag = { key: input, name: input, isGenericItem: true }
        return tag;
    }

    const onValidateTagPickerInput = lookupFieldBasePickerProps?.onValidateInput === undefined
        ? (input: string) => {
            if (input && input.length) {
                return ValidationState.valid;
            }
            else {
                return ValidationState.invalid;
            }
        }
        : lookupFieldBasePickerProps?.onValidateInput;

    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }


    const onResolveSuggestions = lookupFieldBasePickerProps?.onResolveSuggestions === undefined
        ? async (filterText: string, currentTags?: ITag[]): Promise<ITag[]> => {
            if (currentAoo && filterText) {
                let filteredTags = await filterTagsByText(currentAoo.id, filterText);

                if (currentTags)
                    filteredTags = removeTagsPickerDuplicates(filteredTags, currentTags);

                return filteredTags;
            } else {
                return [];
            }
        }
        : lookupFieldBasePickerProps.onResolveSuggestions;

    const filterTagsByText = async (aooId: number, filterText: string): Promise<ITag[]> => {
        let result: any[] = [];
        await fieldsService.getLookupSuggestion(aooId, lookupField.list, filterText.toLowerCase())
            .then(suggestions => {
                result = [...suggestions];
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni`, life: 5000 });

                }

            });;
        return result;
    };

    const removeTagsPickerDuplicates = (items: ITag[], possibleDupes: ITag[]) => {
        return items.filter(contact => possibleDupes.findIndex(el => el.key === contact.key) < 0);
    }


    //const returnMostRecentlyTagsUsed = (currentTags?: ITag[]) => {
    //    if (currentTags)
    //        return removeTagsPickerDuplicates(mostRecentlyTagsUsed, currentTags);
    //    else
    //        return mostRecentlyTagsUsed
    //};


    const onTagselected = (selectedItem: any): ITag | null => {
        //let recent = [...mostRecentlyTagsUsed];
        //recent.push({ selectedItem });

        //assegno l'operatore contains solo alle ricerche fatte aggiungendo un item custom
        // e l'operatore equals alle ricerche fatte attraverso i suggerimenti
        let { search_QueryOperator } = lookupField;

        if (selectedItem.isGenericItem) {
            search_QueryOperator = Search_QueryOperator.Contains;
        } else {
            search_QueryOperator = Search_QueryOperator.Equals;
        }
        props.field.search_QueryOperator = search_QueryOperator;
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramite inputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }


    const onTagChange = (items?: any[]): void => {
        inputChanged({ ...lookupField, internalValue: items });
    };


    return (
        <div className={classNames.inputWrapper}>
            <div className={lookupField.touched && !lookupField.valid ? 'field error' : 'field'}>
                <ArxeiaLabel field={lookupField} />

                <TagPicker
                    key={lookupField.internalName}
                    pickerSuggestionsProps={basePickerSuggestionsProps}
                    getTextFromItem={getTextFromTagItem}
                    createGenericItem={lookupFieldBasePickerProps?.createGenericItem ?? createGenericItem}
                    selectionAriaLabel={'Selected Tags'}
                    removeButtonAriaLabel={'Remove'}
                    resolveDelay={300}
                    disabled={lookupField.readonly || lookupField.disabled}
                    selectedItems={selectedTags}
                    itemLimit={lookupField.multi && props.formMode !== Indici_FormMode.Search ? undefined : 1}
                    componentRef={tagPickerRef}
                    onResolveSuggestions={onResolveSuggestions}
                    onValidateInput={onValidateTagPickerInput}
                    onEmptyResolveSuggestions={lookupFieldBasePickerProps?.onEmptyResolveSuggestions}
                    onItemSelected={onTagselected}
                    onChange={onTagChange}
                />
                {lookupField.touched && !lookupField.valid && <span className="error-message">Campo obbligatorio</span>}

            </div>
        </div>
    );


};


const ForwardedAutocomplete = React.forwardRef(Autocomplete);
export default ForwardedAutocomplete;







function getTextFromTagItem(tag: ITag): string {
    return tag.name as string;
}



